export interface AdjustmentCategoriesProps {
    id: number;
    categoryName: string;
    categoryKey: string;
}

export class AdjustmentCategories {
    private readonly _id: number;
    private readonly _categoryName: string;
    private readonly _categoryKey: string;

    constructor(props: AdjustmentCategoriesProps) {
        this._id = props.id;
        this._categoryName = props.categoryName;
        this._categoryKey = props.categoryKey;
    }

    public get id(): number {
        return this._id;
    }

    public get categoryName(): string {
        return this._categoryName;
    }

    public get categoryKey(): string {
        return this._categoryKey;
    }
}

